import { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row } from "antd";
import styled from "styled-components";
import { TYPE_GET_DATE } from "../../../../helper/const";
import {
  getDateChangeTime,
  formatDataErrorCodeMytel,
} from "../../../../helper/helper";
import FilterTime from "../../../components/FilterTime";
import _ from "lodash";
import Tables from "../../../components/Tables";
import { selectorDataMytelErrorCode } from "../../../../redux/selector";

export default function Overview({ handleGetData, tabActive }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));

  const { revenue = {} } = useSelector(selectorDataMytelErrorCode);
  const { data = [] } = revenue.result || {};
  useEffect(() => {
    if (tabActive !== "1") return;
    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  let dataTableErrorCode = []; 
  for(const date in data){
    const totalItem = _.first(data[date]) || {};
    if(totalItem){
      dataTableErrorCode.push(totalItem);
    }
  }

  dataTableErrorCode = dataTableErrorCode.sort((a, b) => new Date(b.date) - new Date(a.date)); 
  const columnTable = useMemo(() => {
    if (dataTableErrorCode) {
      const data = formatDataErrorCodeMytel(dataTableErrorCode);   
      return data;
    }
  }, [dataTableErrorCode]);

  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2 gap-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>
      
      <Tables
        className="py-2"
        columns={columnTable}
        title="Overview statistic table"
        isHiddenPagination={false}
      />
    </>
  );
}

const Container = styled(Row)`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 20px;

  .item-chart{
    min-width: ${props => `${props.width}px`};
    overflow-x: auto;
  }
`;
